namespace GeniuzPOS.ReportMasterData {
    export interface Report_1505_NRow {
        Id?: string;
        Year?: string;
        BrandCode?: string;
        BrandName?: string;
        TypeSum?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace Report_1505_NRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Year';
        export const localTextPrefix = 'ReportMasterData.Report_1505_N';
        export const deletePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const insertPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const readPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const updatePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            Year = "Year",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            TypeSum = "TypeSum",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
